export const pannelStyles = () => {
  const style = document.createElement('style');
  style.textContent = `
        .validator-panel {
            position: fixed;
            bottom: 0;
            left: 0;
            right: 0;
            background-color:#fafafa;
            border-top: 1px solid #ccc;
            transition: height 0.3s ease;
            height: 80px; /* Collapsed height */
            overflow: hidden;
            z-index: 1000;
        }
        .validator-panel-header {
            display: flex;
            justify-content: space-between;
            align-items: center;
            padding: 10px;
        }
        .validator-panel-content {
            padding: 10px;
            display: none; /* Hidden by default */
            color:black;
            margin:20px;
            height:84vh;
            overflow:auto;
        }
        .validator-panel.expanded {
            height: 95vh; /* Expanded height */
        }
        .validator-panel.expanded .validator-panel-content {
            display: block; /* Show content when expanded */
        }
        .validator-panel-toggle-btn{
          padding:8px;
          font-size:20px;
          font-weight:bold;
           cursor:pointer;
        }
        .validator-panel-close-btn{
          padding:8px;
          font-size:20px;
          font-weight:bold;
          cursor:pointer;
        }
        .panel_tables_body{
        margin:10px;
        }
    `;
  document.head.appendChild(style);
};
export const tableStyles = () => {
  const style = document.createElement('style');
  style.textContent = `
        .event-comparison-table {
            border-collapse: collapse;
            width: 100%;
            margin-top: 20px;
        }
        .event-comparison-table-wrapper{
            display: none; /* Initially hide the table */
        }
    
        .event-comparison-table-wrapper.event-comparison-table-accordian-active {
            display: block; /* Show the table when active */
        }
    
        .event-comparison-table-accordian {
            cursor: pointer;
            background-color: #237b99;
            color: white;
            padding: 12px;
            text-align: left;
            font-size:18px;
            font-weight:bold;
            border: 1px solid #237b99;
            border-radius: 5px;
            margin-top: 20px;
            display: flex; /* Use flexbox for alignment */
            align-items: center; /* Center items vertically */
            justify-content:space-between;
        }
    
        .event-comparison-table-accordian:hover {
            background-color: #1a5e7a; /* Darker shade on hover */
        }
  
        .event-comparison-table-accordian-arrow-icon{
            margin-right: 10px; /* Space between arrow and title */
            transition: transform 0.3s; /* Smooth transition for rotation */
        }
  
        .event-comparison-table-accordian-active .event-comparison-table-accordian-arrow-icon {
            transform: rotate(90deg); /* Rotate arrow when active */
        }
    
        .event-comparison-table caption {
           
            margin-bottom: 10px;
        }
        .ect-caption-box{
            display:flex;
            align-items:center;
            justify-content:space-between;
        }
        .ect-time{
            font-size:14px;
            color:gray;
        }.ect-title{
            font-size: 20px;
        }
    
        .event-comparison-table th, .event-comparison-table td {
            border: 1px solid black;
            padding: 8px;
            text-align: left;
            vertical-align: top;
            max-width:400px;
            word-break: break-word;

        }
    
        .event-comparison-table-colhead th {
            background-color: #f2f2f2;
            text-align: center;
        }
    
        .event-comparison-table-grouphead th {
            background-color: #237b99;
            color: white;
            text-align: center;
        }
        .event-comparison-table summary{
        font-size:16px;
        cursor:pointer;
        }
        .event-comparison-table pre{
            font-size:14px;
            background:#eaeaea;
            position:relative;
            overflow-x: auto;
            white-space: pre-wrap;
            word-wrap: break-word;
        }
        .event-comparison-table .ev-com-checkbox{
        text-align:center;
        }
        .event-comparison-table-wrapper{
          overflow-x:auto;
        }
          .ect-summary-list{
          padding-left:20px;
          margin-top:10px;
          font-size:16px;
          }
          .ect-copybtn{
            position: absolute;
            top:0;
            right:0;
            border: 1px solid teal;
            padding:4px;
            color:black;
            font-size:12px;
            border-radius:8px;
            margin:4px;
            cursor:pointer;
          }
            .ect-copybtn:active{
                background:teal;
                color:white;
            }

        .ect-badges{
        display:flex;
        align-items:center;
        
        }
        .ect-badge{
        margin-right:10px;
        height:24px;
        width:24px;
        border-radius:50%;
        border:1px solid white;
        font-size:12px;
        display:flex;
        justify-content:center;
        align-items:center;
        }
        .ect-badge-fail{
        background:#b72e2e;
        }
        .ect-badge-pass{
           background:#379737; 
        }
        .ect-capture-btn{
            border:none;
            padding:8px;
            border-radius:50%;
            background:transparent;
            cursor:pointer;
            margin-left:8px;
        }
        .ect-capture-btn:hover{
            background:#dde9ed;
        }
            .ect-dlt-btn{
            border:none;
            padding:8px;
            border-radius:50%;
            background:transparent;
            cursor:pointer;
            margin-left:8px;
        }
        .ect-dlt-btn:hover{
            background:#eddde1;
        }
            
      `;
  document.head.appendChild(style);
};
